import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '@environments/environment';
import { CookieService } from 'ngx-cookie-service';
import { addDays, subYears } from 'date-fns';

const API = environment.API;

interface LoginResponse {
  accessToken: string;
}

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  constructor(private http: HttpClient, private cookie: CookieService) {}

  login(email, password) {
    return this.http.post<LoginResponse>(
      `${API}auth`,
      { email, password },
      {
        headers: new HttpHeaders().set(
          'Authorization',
          `Basic ${btoa(email + ':' + password)}`
        )
      }
    );
  }

  logout() {
    return this.http.delete<LoginResponse>(`${API}users/me/session`);
  }

  setCookie(token) {
    if(!environment.DISABLED_COOKIE){
       this.cookie.set('CENCO_TOKEN', token, addDays(new Date(), 1), '/');
      // this.cookie.set('CENCO_TOKEN', token,  addDays(new Date(), 1), '/', '.followcencosud.com', true, 'None');
    }
  }

  deleteCookie() {
    if(!environment.DISABLED_COOKIE){
      this.cookie.set('CENCO_TOKEN', '', subYears(new Date(), 10), '/');
    }else{
      this.cookie.set('CENCO_TOKEN', '', subYears(new Date(), 1), '/', '.followcencosud.com');
      // this.cookie.set('CENCO_TOKEN', '', subYears(new Date(), 1), '/', '.zooft.company');
    }

    this.cookie.delete('CENCO_TOKEN');
  }

  getCookie() {
    return this.cookie.get('CENCO_TOKEN');
  }
}
